<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,2C12,2,10.41,2,10.41,2C10.41,2,10.7,1.71,10.7,1.71C10.89,1.53,11,1.28,11,1C11,0.45,10.55,0,10,0C9.72,0,9.47,0.11,9.29,0.29C9.29,0.29,7.29,2.29,7.29,2.29C7.11,2.47,7,2.72,7,3C7,3.28,7.11,3.53,7.29,3.71C7.29,3.71,9.29,5.71,9.29,5.71C9.47,5.89,9.72,6,10,6C10.55,6,11,5.55,11,5C11,4.72,10.89,4.47,10.71,4.29C10.71,4.29,10.41,4,10.41,4C10.41,4,12,4,12,4C12.55,4,13,4.45,13,5C13,5,13,8,13,8C13,8.55,13.45,9,14,9C14.55,9,15,8.55,15,8C15,8,15,5,15,5C15,3.34,13.66,2,12,2C12,2,12,2,12,2ZM5.71,5.29C5.53,5.11,5.28,5,5,5C5,5,1,5,1,5C0.45,5,0,5.45,0,6C0,6,0,15,0,15C0,15.55,0.45,16,1,16C1,16,8,16,8,16C8.55,16,9,15.55,9,15C9,15,9,9,9,9C9,8.72,8.89,8.47,8.71,8.29C8.71,8.29,5.71,5.29,5.71,5.29C5.71,5.29,5.71,5.29,5.71,5.29ZM7,14C7,14,2,14,2,14C2,14,2,7,2,7C2,7,4,7,4,7C4,7,4,9,4,9C4,9.55,4.45,10,5,10C5,10,7,10,7,10C7,10,7,14,7,14C7,14,7,14,7,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'RotateDocument',
} as DefineComponent
</script>
